import { render } from "./FavSupplierListView.vue?vue&type=template&id=609a5cac&lang=html"
import script from "./FavSupplierListView.vue?vue&type=script&lang=js"
export * from "./FavSupplierListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__